<template>
  <div class="info">
    <Header colorIcons="#9d99a1" />
    <div class="info__text-container">
      <div class="info__first-info-container">
        <div class="info__title-border"></div>
        <div class="info__title-container">
          <div class="info__title">{{store.title}}</div>
          <div class="info__date">{{store.date}}</div>
        </div>
      </div>
      <div class="info__media-icons">
        <svg viewBox="0 0 46.9 47.47" @click="()=>goToSite('/sounds/')">
          <path
            class="cls-1"
            d="M35.18,32.77l-1.41-1.41.7-.7a10,10,0,0,0,0-14.14l-.7-.7,1.41-1.42.7.7a12,12,0,0,1,0,17Z"
          />
          <path
            class="cls-1"
            d="M40.13,37.72l-1.41-1.41.7-.7a17,17,0,0,0,0-24l-.7-.7,1.41-1.42.7.7a19,19,0,0,1,0,26.87Z"
          />
          <path
            class="cls-1"
            d="M30.4,47.5l-20-15.91H.4v-16h10L30.4-.32ZM2.4,29.59h8.69L28.4,43.35V3.82L11.09,17.59H2.4Z"
          />
        </svg>
        <svg
          viewBox="0 0 47.47 47.47"
          fill="#f05a42"
          @click="()=>goToSite('/films/')"
        >
          <path class="cls-1" d="M47.47,33.08H0V-.15H47.47ZM2.37,30.71H45.1V2.23H2.37Z" />
          <rect class="cls-1" x="17.8" y="40.2" width="29.67" height="2.37" />
          <rect class="cls-1" y="40.2" width="8.31" height="2.37" />
          <path
            class="cls-1"
            d="M13.05,47.32A5.93,5.93,0,1,1,19,41.39,5.94,5.94,0,0,1,13.05,47.32Zm0-9.49a3.56,3.56,0,1,0,3.56,3.56A3.57,3.57,0,0,0,13.05,37.83Z"
          />
          <path class="cls-1" d="M16.61,27.62V5.32L34,16.47ZM19,9.67v13.6l10.58-6.8Z" />
        </svg>
      </div>
      <div
        class="info__content"
        v-html="store.content"
      >
      </div>
      <div
        class="info__scroll"
        @mouseenter="scrollDown"
        @mouseleave="scrollBlock"
      >
        <div class="info__scroll-arrow">
          <p>></p>
        </div>
        <div class="info__scroll-text">przewijaj treść</div>
      </div>
    </div>
    <div
      class="info__photo-container info__photoAnimation"
      :key="store.date"
    >
      <div
        class="info__photo-quote"
        v-html="store.photoQuote"
      ></div>
      <div class="info__photo-subcontainer">
        <div
          v-bind:class="store.photoClass2"
          class="info__photoDesc"
        >
          <p>{{store.photoInfo2}}</p>
        </div>
        <div
          v-bind:class="store.photoClass1"
          class="info__photoDesc"
        >
          <p>{{store.photoInfo1}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../store/index.js";
import Header from "../Header/Header";

export default {
  name: "Info",
  components: {
    store,
    Header
  },
  data() {
    return {
    };
  },
  computed: {
    store() {
      return store.state[String(this.$route.params.name)];
    }
  },
  methods: {
    goToSite(site) {
      this.$router.push(site + String(this.$route.params.name));
    },
    goBack() {
      this.$router.go(-1);
    },
    scrollDown() {
      this.intervalID = setInterval(() => {
        const list = document.querySelector(".info__content");
        list.scroll(0, list.scrollTop + 2);
      }, 10);
    },
    scrollBlock() {
      clearInterval(this.intervalID);
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  background-color: #f5edea;
  display: flex;
  justify-content: space-between;
  &__text-container {
    background-color: #fff;
    width: 38%;
    margin-left: 8%;
    min-height: 100vh;
  }
  &__first-info-container {
    display: flex;
    padding-top: 4rem;
    position: relative;
  }
  &__media-icons {
    margin: 1rem 0;
    svg {
      width: 2.5rem;
      margin-left: 1rem;
      cursor: pointer;
    }
  }
  &__title-container {
    margin-left: 1rem;
  }
  &__title-border {
    width: 0.2rem;
    height: 5.8rem;
    background-color: #a9c9b8;
    position: absolute;
    bottom: 0;
  }
  &__title {
    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-size: 3.4rem;
    text-transform: uppercase;
    color: black;
    -webkit-text-fill-color: white;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: black;
  }
  &__date {
    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    border-bottom: 2px solid #f05a42;
    display: flex;
    width: fit-content;
    padding-top: 0.5rem;
    padding-bottom: 0.2rem;
  }
  &__content {
    height: 50vh;
    overflow-y: scroll;
    font-family: "Poppins", sans-serif;
    font-size: 0.8rem;
    padding: 0 1rem;
    line-height: 1.2rem;
    color: #3e3c40;

    @media (max-width: 1024px) {
      font-size: 1rem;
    }
  }
  &__quote {
    margin: 4rem 0 0 1rem;
    width: 80%;
    font-size: 0.7rem;
    font-style: italic;
    font-family: "Poppins", sans-serif;
    line-height: 1rem;
  }
  &__scroll {
    display: flex;
    padding: 3rem 1rem 1rem 1rem;
    align-items: center;
    cursor: pointer;
    max-width: 12rem;
  }
  &__scroll-arrow {
    font-family: Poppins,sans-serif;
    font-size: 1.5rem;
    width: 1.3rem;
    height: 1.3rem;
    transform: rotate(90deg);
    border: 1px solid #000;
    border-radius: 100%;
    justify-content: center;
    text-align: left;
    margin-right: .5rem;
    display: flex;
  }
  &__scroll-text {
    font-family: "Poppins", sans-serif;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #717073;
  }
  &__photo-container {
    width: 50%;
    display: flex;
    position: relative;


  }
  &__photoAnimation {
    animation-name: showPhoto;
    animation-duration: 4s;
    @media (max-width: 1024px) {
      animation: none;
    }
  }
  &__photo-subcontainer {
    width: 100%;
  }
  &__photo-quote {
    position: absolute;
    top: 18%;
    left: 46%;
    display: flex;
    flex-direction: column;
    z-index: 2;
  }
  &__photoDesc {
    position: relative;
    z-index: 1;
    p {
      position: absolute;
      bottom: 2%;
      left: 2%;
      color: rgba(255,255,255,0.6);
    }
  }
  &__photo-m1 {
    width: 46%;
    padding-bottom: 71%;
    float: right;
    margin-top: 8rem;
    background-image: url("./img/m1.jpg");
    background-size: 100%;
    background-repeat: no-repeat;
    box-shadow: 10px 10px 0px -2px rgba(169, 201, 184, 1);
  }

  &__photo-m2 {
    width: 40%;
    padding-bottom: 40%;
    float: right;
    margin: 16rem 0 0 1rem;
    background-image: url("./img/m2.jpg");
    background-size: 100%;
    background-repeat: no-repeat;
    box-shadow: 10px 10px 0px -2px rgba(169, 201, 184, 1);
  }
  &__photo-s1 {
    width: 46%;
    padding-bottom: 71%;
    float: right;
    margin-top: 8rem;
    background-image: url("./img/s1.jpg");
    background-size: 100%;
    background-repeat: no-repeat;
    box-shadow: 10px 10px 0px -2px rgba(169, 201, 184, 1);
  }

  &__photo-s2 {
    width: 40%;
    padding-bottom: 36%;
    float: right;
    margin: 16rem 0 0 1rem;
    background-image: url("./img/s2.jpg");
    background-size: 100%;
    background-repeat: no-repeat;
    box-shadow: 10px 10px 0px -2px rgba(169, 201, 184, 1);
  }

  &__photo-sol1 {
    width: 46%;
    padding-bottom: 71%;
    float: right;
    margin-top: 8rem;
    background-image: url("./img/sol1.png");
    background-size: 100%;
    background-repeat: no-repeat;
    box-shadow: 10px 10px 0px -2px rgba(169, 201, 184, 1);
  }

  &__photo-sol2 {
    width: 40%;
    padding-bottom: 60%;
    float: right;
    margin: 9rem 0 0 1rem;
    background-image: url("./img/sol2.png");
    background-size: 100%;
    background-repeat: no-repeat;
    -webkit-box-shadow: 10px 10px 0px -2px #a9c9b8;
    box-shadow: 10px 10px 0px -2px #a9c9b8;
  }

  &__photo-sama1 {
    width: 46%;
    padding-bottom: 71%;
    float: right;
    margin-top: 8rem;
    background-image: url("./img/sama1.png");
    background-size: 100%;
    background-repeat: no-repeat;
    box-shadow: 10px 10px 0px -2px rgba(169, 201, 184, 1);
  }

  &__photo-sama2 {
    width: 40%;
    padding-bottom: 60%;
    float: right;
    margin: 18rem 0 0 1rem;
    background-image: url("./img/sama2.png");
    background-size: 100%;
    background-repeat: no-repeat;
    -webkit-box-shadow: 10px 10px 0px -2px #a9c9b8;
    box-shadow: 10px 10px 0px -2px #a9c9b8;
  }

  &__photo-zap1 {
    width: 46%;
    padding-bottom: 80%;
    float: right;
    margin-top: 6rem;
    background-image: url("./img/zap1.png");
    background-size: 100%;
    background-repeat: no-repeat;
    box-shadow: 10px 10px 0px -2px rgba(169, 201, 184, 1);
  }

  &__photo-zap2 {
    width: 40%;
    padding-bottom: 60%;
    float: right;
    margin: 12rem 0 0 1rem;
    background-image: url("./img/zap2.png");
    background-size: 100%;
    background-repeat: no-repeat;
    -webkit-box-shadow: 10px 10px 0px -2px #a9c9b8;
    box-shadow: 10px 10px 0px -2px #a9c9b8;
  }

  &__photo-lot1 {
    width: 46%;
    padding-bottom: 80%;
    float: right;
    margin-top: 6em;
    background-image: url("./img/lot1.png");
    background-size: 100%;
    background-repeat: no-repeat;
    box-shadow: 10px 10px 0px -2px rgba(169, 201, 184, 1);
  }

  &__photo-lot2 {
    width: 40%;
    padding-bottom: 60%;
    float: right;
    margin: 12rem 0 0 1rem;
    background-image: url("./img/lot2.png");
    background-size: 100%;
    background-repeat: no-repeat;
    -webkit-box-shadow: 10px 10px 0px -2px #a9c9b8;
    box-shadow: 10px 10px 0px -2px #a9c9b8;
  }
}
@media screen and (max-width: 991px) {
  .info {
  }
}
@media screen and (max-width: 767px) {
  .info {
  }
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #a9c9b8;
}
@keyframes showPhoto {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opaciy: 1;
    transform: translateX(0);
  }
}
</style>
